export const User = 1
export const Script = 2
